import './assets/NcRichText-BKnmtD0n.css';
import NcActionButton from "./Components/NcActionButton.mjs";
import { N as NcActionButtonGroup } from "./chunks/NcActionButtonGroup-CRr3MGWH.mjs";
import NcActionCaption from "./Components/NcActionCaption.mjs";
import NcActionCheckbox from "./Components/NcActionCheckbox.mjs";
import { N as NcActionInput } from "./chunks/NcActionInput-Cz7D7XfL.mjs";
import NcActionLink from "./Components/NcActionLink.mjs";
import NcActionRadio from "./Components/NcActionRadio.mjs";
import NcActionRouter from "./Components/NcActionRouter.mjs";
import { N as NcActions } from "./chunks/NcActions-BNYD2s1x.mjs";
import NcActionSeparator from "./Components/NcActionSeparator.mjs";
import NcActionText from "./Components/NcActionText.mjs";
import NcActionTextEditable from "./Components/NcActionTextEditable.mjs";
import { N as NcAppContent } from "./chunks/NcAppContent-DIojf9zk.mjs";
import NcAppContentDetails from "./Components/NcAppContentDetails.mjs";
import NcAppContentList from "./Components/NcAppContentList.mjs";
import { N as NcAppNavigation } from "./chunks/NcAppNavigation-b745VaE7.mjs";
import { N as NcAppNavigationCaption } from "./chunks/NcAppNavigationCaption-BhT61A8a.mjs";
import NcAppNavigationIconBullet from "./Components/NcAppNavigationIconBullet.mjs";
import { N as NcAppNavigationItem } from "./chunks/NcAppNavigationItem-BgUcekR9.mjs";
import NcAppNavigationList from "./Components/NcAppNavigationList.mjs";
import NcAppNavigationNew from "./Components/NcAppNavigationNew.mjs";
import { N as NcAppNavigationNewItem } from "./chunks/NcAppNavigationNewItem-Di3xZODi.mjs";
import { N as NcAppNavigationSearch } from "./chunks/NcAppNavigationSearch-Bn6ze-K8.mjs";
import { N as NcAppNavigationSettings } from "./chunks/NcAppNavigationSettings-CPtlFWzu.mjs";
import NcAppNavigationSpacer from "./Components/NcAppNavigationSpacer.mjs";
import { N as NcAppSettingsDialog } from "./chunks/NcAppSettingsDialog-BygD2XER.mjs";
import NcAppSettingsSection from "./Components/NcAppSettingsSection.mjs";
import { N as NcAppSidebar } from "./chunks/NcAppSidebar-ClR8nmTm.mjs";
import NcAppSidebarTab from "./Components/NcAppSidebarTab.mjs";
import { N as NcAvatar } from "./chunks/NcAvatar-C1miLzxS.mjs";
import { u } from "./chunks/NcAvatar-C1miLzxS.mjs";
import { N as NcBreadcrumb } from "./chunks/NcBreadcrumb-6-TEgzIX.mjs";
import { N as NcBreadcrumbs } from "./chunks/NcBreadcrumbs-B9rm2Pwq.mjs";
import NcButton from "./Components/NcButton.mjs";
import { N as NcCheckboxRadioSwitch } from "./chunks/NcCheckboxRadioSwitch-Dxh5eqs0.mjs";
import { N as NcCollectionList } from "./chunks/NcCollectionList-DLw6mNFw.mjs";
import { N as NcColorPicker } from "./chunks/NcColorPicker-BUq5h7jz.mjs";
import { N as NcContent } from "./chunks/NcContent-D6FQABFh.mjs";
import NcCounterBubble from "./Components/NcCounterBubble.mjs";
import { N as NcDashboardWidget } from "./chunks/NcDashboardWidget-D7HGohS3.mjs";
import { N as NcDashboardWidgetItem } from "./chunks/NcDashboardWidgetItem-LOg5ztHu.mjs";
import { N as NcDateTime } from "./chunks/NcDateTime-C9kf-YEX.mjs";
import { u as u2 } from "./chunks/NcDateTime-C9kf-YEX.mjs";
import NcDateTimePicker from "./Components/NcDateTimePicker.mjs";
import NcDateTimePickerNative from "./Components/NcDateTimePickerNative.mjs";
import { N as NcDialog } from "./chunks/NcDialog-VincZ0XS.mjs";
import { N as NcDialogButton } from "./chunks/NcDialogButton-JvyN3X6S.mjs";
import NcEllipsisedOption from "./Components/NcEllipsisedOption.mjs";
import { N as NcEmojiPicker } from "./chunks/NcEmojiPicker-1Lmb0vDx.mjs";
import NcEmptyContent from "./Components/NcEmptyContent.mjs";
import NcGuestContent from "./Components/NcGuestContent.mjs";
import { N as NcHeaderMenu } from "./chunks/NcHeaderMenu-Da6Ob-6t.mjs";
import { N as NcHighlight } from "./chunks/index-CsogA-K5.mjs";
import { N as NcIconSvgWrapper } from "./chunks/NcIconSvgWrapper-Ckqpz-vm.mjs";
import NcInputField from "./Components/NcInputField.mjs";
import { N as NcListItem } from "./chunks/NcListItem-C88XN6YO.mjs";
import { N as NcListItemIcon } from "./chunks/NcListItemIcon-B_1SU8D4.mjs";
import NcLoadingIcon from "./Components/NcLoadingIcon.mjs";
import NcModal from "./Components/NcModal.mjs";
import NcNoteCard from "./Components/NcNoteCard.mjs";
import { N as NcPasswordField } from "./chunks/NcPasswordField-BwznS07l.mjs";
import { N as NcPopover } from "./chunks/NcPopover-VxUr4c6P.mjs";
import { N as NcProgressBar } from "./chunks/NcProgressBar-CZtllSde.mjs";
import { N as NcRelatedResourcesPanel } from "./chunks/NcRelatedResourcesPanel-i0NTYqUN.mjs";
import { N as NcMentionBubble } from "./chunks/index-DbA2OZyf.mjs";
import { r } from "./chunks/index-DbA2OZyf.mjs";
import { N as NcAutoCompleteResult, a as NcRichContenteditable } from "./chunks/NcRichContenteditable-CEbFjqp9.mjs";
import { N as NcRichText } from "./chunks/NcRichText-yXF4GYlY.mjs";
import { N, h, d, i, b, r as r2, c, a } from "./chunks/index-BwyQ2N-M.mjs";
import "@vueuse/core";
import "vue";
import "vue-router";
import { a as a2, g, b as b2, c as c2, d as d2, s } from "./chunks/referencePickerModal-DN2oqc6Q.mjs";
import "unist-util-visit";
import "unist-builder";
import "@nextcloud/router";
import "@nextcloud/axios";
import "@nextcloud/sharing/public";
import "@nextcloud/auth";
/* empty css                                                                            */
import { N as NcSelect } from "./chunks/NcSelect-CphXaRDq.mjs";
import { N as NcTextField } from "./chunks/NcTextField-BDlLxIBj.mjs";
import "@nextcloud/event-bus";
import { N as NcSavingIndicatorIcon } from "./chunks/NcSavingIndicatorIcon-Bhy7wcoT.mjs";
import { N as NcSelectTags } from "./chunks/NcSelectTags-Dj3rLyZe.mjs";
import { N as NcSettingsInputText } from "./chunks/NcSettingsInputText-DERFu-YS.mjs";
import { N as NcSettingsSection } from "./chunks/NcSettingsSection-CmmnCHg2.mjs";
import { N as NcSettingsSelectGroup } from "./chunks/NcSettingsSelectGroup-BQc8lPh6.mjs";
import NcTextArea from "./Components/NcTextArea.mjs";
import { N as NcTimezonePicker } from "./chunks/NcTimezonePicker-BSkLspq1.mjs";
import { N as NcUserBubble } from "./chunks/NcUserBubble-B_i04DHm.mjs";
import { N as NcUserStatusIcon } from "./chunks/NcUserStatusIcon-DZIISraw.mjs";
import NcVNodes from "./Components/NcVNodes.mjs";
import { isFullscreenState, useIsFullscreen } from "./Composables/useIsFullscreen.mjs";
import { MOBILE_BREAKPOINT, MOBILE_SMALL_BREAKPOINT, isMobileState, useIsMobile, useIsSmallMobile } from "./Composables/useIsMobile.mjs";
import { isA11yActivation } from "./Functions/a11y.mjs";
import { E, a as a3, e, g as g2, s as s2 } from "./chunks/emoji-V6ytyzoR.mjs";
import { u as u3 } from "./chunks/usernameToColor-zLYstN5o.mjs";
import { directive } from "./Directives/Focus.mjs";
import { directive as directive$1 } from "./Directives/Linkify.mjs";
import "./Directives/Tooltip.mjs";
import { default as default2 } from "./Mixins/clickOutsideOptions.mjs";
import { default as default3 } from "./Mixins/isFullscreen.mjs";
import { default as default4 } from "./Mixins/isMobile.mjs";
import { VTooltip } from "floating-vue";
import { VTooltip as VTooltip2 } from "floating-vue";
const NcComponents = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NcActionButton,
  NcActionButtonGroup,
  NcActionCaption,
  NcActionCheckbox,
  NcActionInput,
  NcActionLink,
  NcActionRadio,
  NcActionRouter,
  NcActionSeparator,
  NcActionText,
  NcActionTextEditable,
  NcActions,
  NcAppContent,
  NcAppContentDetails,
  NcAppContentList,
  NcAppNavigation,
  NcAppNavigationCaption,
  NcAppNavigationIconBullet,
  NcAppNavigationItem,
  NcAppNavigationList,
  NcAppNavigationNew,
  NcAppNavigationNewItem,
  NcAppNavigationSearch,
  NcAppNavigationSettings,
  NcAppNavigationSpacer,
  NcAppSettingsDialog,
  NcAppSettingsSection,
  NcAppSidebar,
  NcAppSidebarTab,
  NcAutoCompleteResult,
  NcAvatar,
  NcBreadcrumb,
  NcBreadcrumbs,
  NcButton,
  NcCheckboxRadioSwitch,
  NcCollectionList,
  NcColorPicker,
  NcContent,
  NcCounterBubble,
  NcDashboardWidget,
  NcDashboardWidgetItem,
  NcDateTime,
  NcDateTimePicker,
  NcDateTimePickerNative,
  NcDialog,
  NcDialogButton,
  NcEllipsisedOption,
  NcEmojiPicker,
  NcEmptyContent,
  NcGuestContent,
  NcHeaderMenu,
  NcHighlight,
  NcIconSvgWrapper,
  NcInputField,
  NcListItem,
  NcListItemIcon,
  NcLoadingIcon,
  NcMentionBubble,
  NcModal,
  NcNoteCard,
  NcPasswordField,
  NcPopover,
  NcProgressBar,
  NcRelatedResourcesPanel,
  NcRichContenteditable,
  NcRichText,
  NcSavingIndicatorIcon,
  NcSelect,
  NcSelectTags,
  NcSettingsInputText,
  NcSettingsSection,
  NcSettingsSelectGroup,
  NcTextArea,
  NcTextField,
  NcTimezonePicker,
  NcUserBubble,
  NcUserStatusIcon,
  NcVNodes
}, Symbol.toStringTag, { value: "Module" }));
const NcDirectives = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Focus: directive,
  Linkify: directive$1,
  Tooltip: VTooltip
}, Symbol.toStringTag, { value: "Module" }));
const NextcloudVuePlugin = {
  install(Vue) {
    Object.entries(NcComponents).forEach(([name, component]) => {
      Vue.component(component.name || name, component);
    });
    Object.entries(NcDirectives).forEach(([name, directive2]) => {
      Vue.directive(name, directive2);
    });
  }
};
export {
  E as EmojiSkinTone,
  directive as Focus,
  directive$1 as Linkify,
  MOBILE_BREAKPOINT,
  MOBILE_SMALL_BREAKPOINT,
  NcActionButton,
  NcActionButtonGroup,
  NcActionCaption,
  NcActionCheckbox,
  NcActionInput,
  NcActionLink,
  NcActionRadio,
  NcActionRouter,
  NcActionSeparator,
  NcActionText,
  NcActionTextEditable,
  NcActions,
  NcAppContent,
  NcAppContentDetails,
  NcAppContentList,
  NcAppNavigation,
  NcAppNavigationCaption,
  NcAppNavigationIconBullet,
  NcAppNavigationItem,
  NcAppNavigationList,
  NcAppNavigationNew,
  NcAppNavigationNewItem,
  NcAppNavigationSearch,
  NcAppNavigationSettings,
  NcAppNavigationSpacer,
  NcAppSettingsDialog,
  NcAppSettingsSection,
  NcAppSidebar,
  NcAppSidebarTab,
  NcAutoCompleteResult,
  NcAvatar,
  NcBreadcrumb,
  NcBreadcrumbs,
  NcButton,
  NcCheckboxRadioSwitch,
  NcCollectionList,
  NcColorPicker,
  NcContent,
  NcCounterBubble,
  N as NcCustomPickerRenderResult,
  NcDashboardWidget,
  NcDashboardWidgetItem,
  NcDateTime,
  NcDateTimePicker,
  NcDateTimePickerNative,
  NcDialog,
  NcDialogButton,
  NcEllipsisedOption,
  NcEmojiPicker,
  NcEmptyContent,
  NcGuestContent,
  NcHeaderMenu,
  NcHighlight,
  NcIconSvgWrapper,
  NcInputField,
  NcListItem,
  NcListItemIcon,
  NcLoadingIcon,
  NcMentionBubble,
  NcModal,
  NcNoteCard,
  NcPasswordField,
  NcPopover,
  NcProgressBar,
  NcRelatedResourcesPanel,
  NcRichContenteditable,
  NcRichText,
  NcSavingIndicatorIcon,
  NcSelect,
  NcSelectTags,
  NcSettingsInputText,
  NcSettingsSection,
  NcSettingsSelectGroup,
  NcTextArea,
  NcTextField,
  NcTimezonePicker,
  NcUserBubble,
  NcUserStatusIcon,
  NcVNodes,
  NextcloudVuePlugin,
  VTooltip2 as Tooltip,
  a2 as anyLinkProviderId,
  default2 as clickOutsideOptions,
  a3 as emojiAddRecent,
  e as emojiSearch,
  g2 as getCurrentSkinTone,
  g as getLinkWithPicker,
  b2 as getProvider,
  c2 as getProviders,
  h as hasInteractiveView,
  isA11yActivation,
  d as isCustomPickerElementRegistered,
  default3 as isFullscreen,
  isFullscreenState,
  default4 as isMobile,
  isMobileState,
  i as isWidgetRegistered,
  b as registerCustomPickerElement,
  r2 as registerWidget,
  c as renderCustomPickerElement,
  a as renderWidget,
  r as richEditor,
  d2 as searchProvider,
  s2 as setCurrentSkinTone,
  s as sortProviders,
  u2 as useFormatDateTime,
  useIsFullscreen,
  useIsMobile,
  useIsSmallMobile,
  u as userStatus,
  u3 as usernameToColor
};
